<template>
  <g>
    <path
      d="M15.5 11.0002C16.3284 11.0002 17 10.3287 17 9.50024C17 8.67182 16.3284 8.00024 15.5 8.00024C14.6716 8.00024 14 8.67182 14 9.50024C14 10.3287 14.6716 11.0002 15.5 11.0002Z"
    />
    <path
      d="M8.5 11.0002C9.32843 11.0002 10 10.3287 10 9.50024C10 8.67182 9.32843 8.00024 8.5 8.00024C7.67157 8.00024 7 8.67182 7 9.50024C7 10.3287 7.67157 11.0002 8.5 11.0002Z"
    />
    <path
      d="M11.99 2.00024C6.47 2.00024 2 6.48024 2 12.0002C2 17.5202 6.47 22.0002 11.99 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 11.99 2.00024ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 7.58024 7.58 4.00024 12 4.00024C16.42 4.00024 20 7.58024 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002ZM16.41 13.8902C16.06 13.6702 15.59 13.7802 15.38 14.1302C14.64 15.3002 13.38 16.0002 12 16.0002C10.62 16.0002 9.36 15.3002 8.62 14.1202C8.4 13.7702 7.94 13.6602 7.59 13.8802C7.24 14.1002 7.13 14.5602 7.35 14.9102C8.37 16.5402 10.1 17.5002 12 17.5002C13.9 17.5002 15.63 16.5302 16.65 14.9202C16.87 14.5702 16.76 14.1102 16.41 13.8902Z"
    />
  </g>
</template>
